import React from 'react';

export const parseParagraph = (
  text: string,
  className: string
): JSX.Element[] =>
  text.split('\n').map(
    (element: string, idx): JSX.Element => (
      <p key={idx} className={className}>
        {element}
      </p>
    )
  );
